const request = {
    message_rate_limited: 'ส่งข้อความถึงผู้รับรายนี้มากเกินไป โปรดลองอีกครั้งในภายหลัง',
    invalid_input: 'ข้อมูลที่ป้อนไม่ถูกต้อง {{details}}',
    general: 'เกิดข้อผิดพลาดในการร้องขอ',
    range_not_satisfiable: 'ช่วงข้อมูลไม่ตรงตามข้อกำหนด',
    feature_not_supported: 'ฟีเจอร์นี้ไม่รองรับในสภาพแวดล้อมปัจจุบัน',
    rate_limited: 'มีคำขอมากเกินไป โปรดลองใหม่อีกครั้งในภายหลัง',
};
export default Object.freeze(request);
